import React, { useState } from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { Icon } from '@plone/volto/components';
import { Segment, Message, Button, Grid } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { isEmpty } from 'lodash';

import navTreeSVG from '@plone/volto/icons/nav.svg';

import ImageBanner from './components/ImageBanner';

const messages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
});

const HomeBannerEdit = (props) => {
  const { block, data, openObjectBrowser, onChangeBlock } = props;

  const intl = useIntl();
  const [slideIndex, setSlideIndex] = useState(0);

  const items = data?.items || [];

  const handleClick = () => {
    openObjectBrowser({
      mode: 'image',
      selectableTypes: ['Image'],
      allowExternals: false,
      currentPath: '/',
      onSelectItem: (_url, item) => {
        const newItems = [...items];

        newItems[slideIndex] = {
          ...newItems[slideIndex],
          image: [
            {
              '@id': item['@id'],
              Title: item.Title,
              Description: item.Description,
              title: item.Title,
              image_field: item.image_field,
              hasPreviewImage: item.hasPreviewImage,
            },
          ],
          alt: item?.Description || '',
        };

        onChangeBlock(block, {
          ...data,
          items: newItems,
        });
      },
    });
  };

  if (isEmpty(items)) {
    return (
      <Message>
        <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
      </Message>
    );
  }

  return (
    <div className="mpf-banner-topo">
      <div className="mpf-banner-topo__carousel">
        {/* TRACK */}
        <div
          className="mpf-banner-topo__track"
          style={{
            display: 'flex',
            transform: `translateX(-${slideIndex * 100}%)`,
            transition: 'transform 0.5s ease',
          }}
        >
          {items.map((item, index) => (
            <div key={index} style={{ minWidth: '100%' }}>
              {!isEmpty(item.image) ? (
                <ImageBanner image={item.image} alt={item.alt} />
              ) : (
                <Segment placeholder>
                  <Grid textAlign="center" verticalAlign="middle">
                    <Grid.Row>
                      <Grid.Column className="ui form">
                        <h4>
                          {intl.formatMessage(messages.PleaseChooseContent)}
                        </h4>
                        <Button onClick={handleClick} icon>
                          <Icon name={navTreeSVG} />
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              )}
            </div>
          ))}
        </div>

        {/* CONTROLS */}
        <div className="mpf-banner-topo__controls">
          <Button
            disabled={slideIndex === 0}
            onClick={() => setSlideIndex((prev) => prev - 1)}
          >
            {intl.formatMessage({ id: 'Previous', defaultMessage: 'Anterior' })}
          </Button>

          <Button
            disabled={slideIndex === items.length - 1}
            onClick={() => setSlideIndex((prev) => prev + 1)}
          >
            {intl.formatMessage({ id: 'Next', defaultMessage: 'Próximo' })}
          </Button>
        </div>

        {/* DOTS */}
        <div className="mpf-banner-topo__bullets">
          {items.map((_, index) => (
            <button
              key={index}
              onClick={() => setSlideIndex(index)}
              className={`mpf-banner-topo__bullet glide__bullet ${index === slideIndex ? 'active' : ''}`}
              type="button"
              aria-label={`Ir para o slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default withBlockExtensions(HomeBannerEdit);
